import { vuwer } from "@@assets/scripts/common";
import "@@assets/klass/VuwSlider";

vuwer.add("sliderSection", {
	selector: "#slider_section"
}, function() {
	this
	.add("slider", {
		selector: () => this.$self.find(".vuw-slider").eq(0),
		vuwType: "slider",
		sliderOptions: {
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: "#slider_pagination",
				clickable: true
			}
		}
	})
});
